module.exports = __webpack_public_path__ + "img/speedometer.fe6a522f.svg";